import { defineStore } from 'pinia'
import { useStorage } from '@vueuse/core'

// eslint-disable-next-line no-undef
const { __ } = wp.i18n

const stagesDefault = [
  {
    active: true,
    valid: false,
    validated: false,
  },
  {
    active: false,
    valid: false,
    validated: false,
  },
  {
    active: false,
    valid: false,
    validated: false,
  },
  {
    active: false,
    valid: false,
    validated: false,
  },
  {
    active: false,
    valid: false,
    validated: false,
  },
  {
    active: false,
    valid: false,
    validated: false,
  },
  {
    active: false,
    valid: false,
    validated: false,
  },
]

export const useStagesStore = defineStore('stages', {
  state: () => {
    return {
      stages: useStorage('stages', stagesDefault),
      activeRoom: useStorage('activeRoom', 0),
      ajaxLoading: false,
      apiData: {},
      values: useStorage('values', { rooms: {} }),
    }
  },
  getters: {
    isLastStep() {
      return this.currentStep === this.stages.length - 1
    },
    currentStep() {
      return this.stages.findIndex((step) => step.active === true)
    },
    canNext() {
      // for (let i = 0; i <= this.currentStep; i++) {
      //   if (!this.stages[i].valid) {
      //     return false
      //   }
      // }

      return this.stages[this.currentStep].valid
    },
    currentStageData() {
      return this.stages[this.currentStep]
    },
    inventories() {
      const inv = []

      if (Object.keys(this.values.rooms).length) {
        this.values.rooms.map((room) => {
          const { inventories } = room

          inventories.map((inventory) => {
            if (inventory.count * 1 > 0) {
              inv.push(inventory)
            }
          })
        })
      }

      return inv
    },
    latestValidIndex() {
      for (let i = 0; i <= this.stages.length - 1; i++) {
        if (!this.stages[i].valid) {
          return i - 1
        }
      }

      return -1
    },
  },
  actions: {
    setValidated(newVal) {
      this.stages[this.currentStep].validated = newVal
    },
    isValid(step) {
      return this.stages[step]?.valid
    },
    setValid(newVal) {
      this.stages[this.currentStep].valid = newVal
    },
    setPassed(newVal) {
      this.stages[this.currentStep].passed = newVal
    },
    reset() {
      this.stages = stagesDefault
      this.currentStage = 0
      this.activeRoom = 0
      this.values = { rooms: this.apiData.rooms }
    },
    setApiData(data) {
      this.apiData = data

      if (!Object.keys(this.values.rooms).length) {
        const { rooms } = data
        this.values.rooms = rooms
      }
    },
    goStep(go) {
      this.stages.map((step, index) => {
        if (go === index) {
          step.active = true
        } else {
          step.active = false
        }
      })
    },
    updateState(name, val) {
      this[name] = val
    },
    updateValues(key, val) {
      this.values[key] = val
    },
  },
  methods: {
    __,
  },
})
